export default __webpack_public_path__ + "static/media/App_Store.bc588dbd.svg";